// import moment from 'moment'
export const users = [
    {
        id: 1,
        name: "John Salins",
        firstname: "John Salinas",
        email: "john@macheenist.com",
        avatar: '/john.jpg',
        phone: "+918520154870",
        company: "Google",
        job: "Web Designer",
        birthdate: "05-14-1999",
        address: "642 Stillwater St.Downers Grove, IL 60515",
        notes: "Create and present administrator and operator training information",
        is_important: true,
        is_recent: true,
        selected: false
    },
    {
        id: 2,
        name: "Atul Verma",
        firstname: "Atul Verma",
        email: "jack@example.com",
        avatar: '/atul.jpg',
        phone: "+919874563215",
        company: "Apple",
        job: "Hacker",
        birthdate: "01-08-1999",
        address: "8020 Manhattan Ave.Stillwater, MN 55082",
        notes: "Create a solution maintenance plan",
        is_important: false,
        is_recent: true,
        selected: false
    },
    {
        id: 3,
        name: "Bruce Canta",
        firstname: "Bruce Canta",
        email: "bruce@example.com",
        avatar: '/3.jpg',
        phone: "+919456874560",
        company: "HCL Technologies",
        job: "Web Developer",
        birthdate: "04-15-1989",
        address: "725 Applegate Street Mount Pleasant, SC 29464",
        notes: "Tivoli Business Systems Manager SQL server jobs",
        is_important: true,
        is_recent: false,
        selected: false
    },
    {
        id: 4,
        name: "Camelia Lopez",
        firstname: "Camelia Lopez",
        email: "camelia@example.com",
        avatar: '/4.jpg',
        phone: "+914851236450",
        company: "Infosys",
        job: "Theme Designer",
        birthdate: "06-18-2000",
        address: "7716 Old Leeton Ridge Ave.Whitehall, PA 18052",
        notes: "Set up and test jobs on the database server to produce the database backup.",
        is_important: true,
        is_recent: true,
        selected: false
    },
    {
        id: 5,
        name: "Denis Richard",
        firstname: "Denis Richard",
        email: "denis@example.com",
        avatar: '/5.jpg',
        phone: "+811451203654",
        company: "Wipro",
        job: "Software Developer",
        birthdate: "09-04-1997",
        address: "47 Whitemarsh Street Mount Holly, NJ 08060",
        notes: "Install the Tivoli Business Systems Manager health monitor software.",
        is_important: false,
        is_recent: false,
        selected: false
    },
    {
        id: 6,
        name: "Mia Willson",
        firstname: "Mia Willson",
        email: "mia@example.com",
        avatar: '/6.jpg',
        phone: "+154579602123",
        company: "Oracle Financial Services Software",
        job: "Database Developer",
        birthdate: "05-06-1994",
        address: "541 Beach StreetPort Chester, NY 10573",
        notes: "Evaluate the addition and deletion of user IDs.",
        is_important: true,
        is_recent: false,
        selected: false
    }
];

export const authUser = users[0];



export const defaultUserPic = "/1-default.jpg";
